import { logo } from "@/store/config";
import {
	razorpayMTPLKey,
	razorPayMTGPLKey,
	SHARECHAT_API_DOMAIN
	// razorpayMojKey
	// SHARECHAT_DOMAIN
} from "../../config/index";

const downloadRazorPayScriptCreator = () => {
	let promise;
	return () => {
		if (promise) {
			return promise;
		}
		promise = new Promise((resolve, reject) => {
			// eslint-disable-next-line no-undef
			const script = document.createElement("script");
			script.type = "text/javascript";
			script.async = true;
			script.onload = resolve;
			script.onerror = reject;
			script.src = "https://checkout.razorpay.com/v1/checkout.js";
			// eslint-disable-next-line no-undef
			document.body.appendChild(script);
		});
		return promise;
	};
};

export const downloadRazorPayScript = downloadRazorPayScriptCreator();

export function initRazorPayModal({
	amount,
	orderId,
	name,
	contact,
	isJeet11Distributor,
	notes,
	useMTPLKey,
	isMojAgency,
	redirectionParams
}) {
	return downloadRazorPayScript().then(
		() =>
			new Promise((resolve, reject) => {
				const jsonRedirectionParams = encodeURIComponent(
					JSON.stringify(redirectionParams)
				);
				const pathname = (window && window.location.pathname) || "";
				const referrer = window && window.location.origin;
				let options = {
					key: useMTPLKey
						? isMojAgency
							? razorpayMTPLKey
							: razorpayMTPLKey
						: razorPayMTGPLKey,
					amount: amount * 100,
					currency: "INR",
					name: "JEET 11",
					// description,
					image: logo,
					order_id: orderId,
					handler: resolve,
					modal: {
						ondismiss: reject
					},
					prefill: {
						name,
						contact
					},
					theme: {
						color: "#01A1FC"
					},
					notes,
					redirect: true,
					callback_url: `${SHARECHAT_API_DOMAIN}/payments-api-gateway/v1/external/public/static/razorpayCallback?tenant=offlineRecharge&referrer=${referrer +
						pathname}&additionalParams=${jsonRedirectionParams}`
				};
				if (isJeet11Distributor) {
					options = {
						...options,
						method: {
							netbanking: false,
							card: false,
							wallet: false,
							emi: false,
							upi: true
						}
					};
				}
				// eslint-disable-next-line no-undef
				const rzp1 = new window.Razorpay(options);
				rzp1.open();
			})
	);
}
